<template>
<div>
  <div class="row">
    <div class="col-md-8 mb-4">
      <p>Titre</p>
      <b-form-input
      :value="quiz.title | translategrader($i18n.locale)"
      placeholder="Titre de la section"
      @input="updateSurveySimpleField($event, 'title')">
      </b-form-input>
    </div>
    <div class="col-md-1 mb-4 offset-md-1">
      <p>Ordre</p>
      <b-form-input v-model="quiz.order" placeholder="Ordre de la section" @input="updateOrder"></b-form-input>
    </div>
    <div class="col-md-2 mb-4">
      <p>Couleur
      <span class="colorDemo" :style="bgc" @click="showColorPicker()">&nbsp;</span></p>
      <div class="colorPicker">
        <photoshop-picker :value="tempColor" @input="updateTempColor" @ok="updateColor" @cancel="closeColorPicker" v-if="showingColorPicker"></photoshop-picker>
      </div>
      <b-form-input v-model="quiz.color" placeholder="Couleur de la section" @click="showColorPicker()"></b-form-input>
    </div>
    <b-col md="12">
      <h4>Image de header</h4>
    </b-col>
    <b-col md="4">
      <b-button @click="open_uploadcare">Sélectionner une image</b-button>
      <p class="text-info pt-2 small">Taille suggérée : 1440 x 900px</p>
    </b-col>
    <b-col md="8">
      <img :src="quiz.background_image" class="img-fluid" />

    </b-col>
  </div>

  <!-- Uploadcare -->
  <!-- <div>
    <b-button v-b-modal.modal-1>Image background upload</b-button>

    <b-modal id="modal-1" title="BootstrapVue">
      <p class="my-4">Hello from modal!</p>
          <input
      type="hidden"
      role="uploadcare-uploader" />
    </b-modal>
  </div> -->

  <hr>

  <div class="row">
    <div class="col" v-if="viewHTML !== true">
      <p>Texte d'accroche (switch to <strong><a @click="viewHTML = true">html view</a></strong>)</p>
      <div id="toolbar">
        <span class="ql-formats">
          <button class="ql-bold"></button>
          <button class="ql-italic"></button>
          <button class="ql-underline"></button>
          <button class="ql-strike"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-script" value="sub"></button>
          <button class="ql-script" value="super"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-list" value="ordered"></button>
          <button class="ql-list" value="bullet"></button>
          <button class="ql-indent" value="-1"></button>
          <button class="ql-indent" value="+1"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-direction" value="rtl"></button>
          <select class="ql-align"></select>
        </span>
        <span class="ql-formats">
          <button class="ql-link"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-clean"></button>
        </span>
      </div>
      <div
        label="Texte d'accroche"
        :value="descriptionHTML"
        @input="updateDescriptionHTML"
        id="accroche"
      >
        <div v-html="descriptionHTML"></div>
      </div>
      <div style = "clear:both"></div>
    </div>
    <div class="col" v-if="viewHTML === true">
      <p>Texte d'accroche (switch to <strong><a @click="viewHTML = false; loadHTMLEditor()">visual view</a></strong>)</p>
        <b-form-textarea
          id="textarea_description"
          :value="quiz.description | translategrader($i18n.locale)"
          @input="updateSurveySimpleField($event, 'description')"
          placeholder="Texte d'accorche"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      <div style = "clear:both"></div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 mt-5">
      <p><b>Messages de conclusion</b></p>
    </div>
    <div class="col-4">
      <label for="textarea_accroche_success" class="text-success">Bien joué</label>
      <b-form-textarea
          id="textarea_accroche_success"
          :value="quiz.results['good'] | translategrader($i18n.locale)"
          @input="updateResults($event, 'good')"
          placeholder="Bien joué"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
    </div>
    <div class="col-4">
      <label for="textarea_accroche_success" class="text-warning">Score moyen</label>
      <b-form-textarea
          id="textarea_accroche_success"
          :value="quiz.results['average'] | translategrader($i18n.locale)"
          @input="updateResults($event, 'average')"
          placeholder="C'est moyen"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
    </div>
    <div class="col-4">
      <label for="textarea_accroche_success" class="text-danger">Mauvais score</label>
      <b-form-textarea
          id="textarea_accroche_success"
          :value="quiz.results['bad'] | translategrader($i18n.locale)"
          @input="updateResults($event, 'bad')"
          placeholder="Pas bon"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
    </div>
  </div>
</div>

</template>

<script>

  import { mapMutations, mapGetters } from 'vuex';
  import { UPDATE_INFORMATION, UPDATE_BACKGROUND_IMAGE } from '@/store/quiz/mutations';
  import { Photoshop } from 'vue-color'

  export default {
    name: "quiz-information",

    data() {
      return {
        showingColorPicker: false,
        tempColor: "#fff",
        viewHTML: false,
      }
    },

    components: {
      'photoshop-picker': Photoshop,
    },

    mounted() {
      setTimeout( () => {
        this.loadHTMLEditor();
      }, 500);
    },



    computed: {
      ...mapGetters('quiz', {
        quiz: 'newQuiz'
      }),

      bgc() {
        return {backgroundColor: this.quiz.color}
      },

      lang : function() {
        return this.$i18n.locale;
      },

      myLocale : function() {
        return this.$i18n.locale;
      },

      descriptionHTML : function() {
        return this.$options.filters.translategrader(this.quiz.description,this.$i18n.locale);
      }
    },

    watch: {
      myLocale: function (newLocale, oldLocale) {
        this.viewHTML = true; // Force destruction of Quill DOM
        this.loadHTMLEditor()
      }
    },

    methods: {

      ...mapMutations('quiz', {
        updateInformation: UPDATE_INFORMATION,
        updateBackgroundImage: UPDATE_BACKGROUND_IMAGE
      }),

      loadHTMLEditor() {
        setTimeout( () => {
          this.viewHTML = false;
        }, 300); // Needed when change of lang
        var toolbarOptions = {
        container: '#toolbar'}

        var options = {
              format: ['bold', 'italic', 'link', 'strike', 'script', 'underline'],
              theme: 'snow',
              modules: {
                toolbar: toolbarOptions
              }
            };

        setTimeout( () => {
          var quill = new Quill('#accroche', options);
        }, 300);
      },

      updateSurveySimpleField(value, targetKey) {
        // Saving objects in current language
        var tmpSurvey = Object.assign({}, this.quiz);

        if (typeof this.$i18n.locale === "undefined") {
          tmpSurvey[targetKey] = value;
          // we might need to cover multi-> single languages at some point
          // (or just fallback "en" or "fr" by default)
        } else {

          if (tmpSurvey[targetKey].constructor == Object) {
            // If we already have a lang dict
            tmpSurvey[targetKey][this.$i18n.locale] = value;
          } else {
            // else we have a non-multiligual string. We need to erase it first
            delete tmpSurvey[targetKey];
            tmpSurvey[targetKey] = {};
            tmpSurvey[targetKey][this.$i18n.locale] = value;
          }
        }
        this.updateLocalStore(tmpSurvey);

      },

      updateLocalStore(dictObject) {
        this.updateInformation({
          title: dictObject.title,
          order: dictObject.order,
          color: dictObject.color,
          description: dictObject.description,
          results: dictObject.results
        })
      },

      updateOrder(value) {
        this.updateInformation({
          title: this.quiz.title,
          order: value,
          color: this.quiz.color,
          description: this.quiz.description,
          results: this.quiz.results
        })
      },

      updateDescriptionHTML(value) {
        this.updateSurveySimpleField(value.target.innerHTML, "description")
      },

      updateTempColor(value) {
        this.tempColor = value.hex;
      },

      updateColor() {
        this.updateInformation({
          description: this.quiz.description,
          order: this.quiz.order,
          color: this.tempColor,
          title: this.quiz.title,
          results: this.quiz.results
        })
        this.closeColorPicker();
      },

      showColorPicker () {
        this.tempColor = this.quiz.color;
        this.showingColorPicker = true;
      },

      closeColorPicker () {
        this.showingColorPicker = false;
      },

      open_uploadcare () {
        // var dialog = uploadcare.openDialog(this.quiz.background_image);
        var currentComponent = this;
        var fileInput = document.createElement('input');
        var widget = uploadcare.Widget(fileInput);
        widget.onUploadComplete(function(info) {
          console.log("File info!", info.cdnUrl);
          currentComponent.updateBackgroundImage(info.cdnUrl)
        });
        widget.openDialog();
      },

      updateResults(value, key) {
        // Saving objects in current language
        var tmpSurvey = Object.assign({}, this.quiz);

        if (typeof this.$i18n.locale === "undefined") {
          tmpSurvey.results[key] = value;
          // we might need to cover multi-> single languages at some point
          // (or just fallback "en" or "fr" by default)
        } else {
          if (tmpSurvey.results[key].constructor == Object) {
            // If we already have a lang dict
            tmpSurvey.results[key][this.$i18n.locale] = value;
          } else {
            // else we have a non-multiligual string. We need to erase it first
            delete tmpSurvey.results[key];
            tmpSurvey.results[key] = {};
            tmpSurvey.results[key][this.$i18n.locale] = value;
          }
        }

        this.updateLocalStore(tmpSurvey);
      }
    }
  }
</script>

<style scoped>

a {
  cursor: pointer;
}

.ql-container {
  height: auto;
}

.colorDemo {
  float: right;
  width: 15px;
  height: 15px;
  border: 1px solid #DDD;
  background-color: #0000F2;
}

.colorPicker {
  position: relative;
  z-index: 99;
}

.vc-photoshop {
  position: absolute;
  right: 0px;
  top: 50px;
}


.btn-secondary {
  color: #fff!important;
  background-color: #6c757d!important;
  border-color: #6c757d!important;
}

</style>



// WEBPACK FOOTER //
// src/components/quiz/QuizInformation.vue